import axios from "axios";
import { buildTargetList } from "./reference-list-helper.js";
import { addMessage } from "./messages.js";

const modalClosingEvent = new Event("modal-closing");

const init = function init() {
  [].slice
    .call(document.querySelectorAll(".reference-modal-opener"))
    .map(function (modalOpener) {
      modalOpener.addEventListener(
        "modal-opener-called",
        function () {
          const action = modalOpener.getAttribute("data-target");
          const modalSelector = `.modal[data-target='${action}']`;
          let modal = {
            modal: document.querySelector(modalSelector),
            buttonList: document.querySelector(
              modalSelector + " .target-list-buttons",
            ),
            closingEvent: modalClosingEvent,
            recordId: modalOpener.getAttribute("data-record"),
            sourceListId: modalOpener.getAttribute("data-list"),
          };

          // Add title of selected record to modal
          document
            .querySelector(modalSelector + " .entry-title")
            .replaceChildren(
              document.createTextNode(
                modalOpener.getAttribute("data-record-title"),
              ),
            );

          if (action === "delete") {
            // Delete Entry Modal
            const deleteButton = modal.modal.querySelector(
              "#delete-entry-button",
            );
            const clickHandler = function (e) {
              e.preventDefault();
              axios
                .post(
                  `/api/reference-lists/${modal.sourceListId}/delete-entry`,
                  {
                    recordId: modal.recordId,
                  },
                )
                .then(function (response) {
                  addMessage(response.data, "success");
                  const box = document.getElementById(modal.recordId);
                  if (box) {
                    box.parentNode.removeChild(box);
                  }
                  deleteButton.removeEventListener(
                    "click",
                    clickHandler,
                    false,
                  );
                })
                .catch(function (error) {
                  if (error.status === 403) {
                    addMessage(error.response.data, "danger");
                  }
                  console.log(error);
                });
              modal.modal.classList.remove("is-active");
              modal.modal.dispatchEvent(modalClosingEvent);
            };
            deleteButton.addEventListener("click", clickHandler, false);
          } else {
            // Clear target list
            modal.buttonList.replaceChildren();

            // Build target list
            buildTargetList(modal, action);
          }
        },
        false,
      );
    });
};
window.addEventListener("load", init, false);
